module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Glossary"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Glossary")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "4px"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("ABTU")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Auto-Bronetankovoe Upravlenie")]), _vm._v(" (Main Tank Directorate), 1934–40.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("AFV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Armoured Fighting Vehicle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("AOK")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Armeeoberkommando (Army)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("AP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Armour Piercing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("APCBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Armour Piercing Composite Ballistic Cap (steel core)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("APCR")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Armour Piercing Composite Rigid (tungsten core)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("APHE")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Armour Piercing High Explosive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("C"), _c('sup', [_vm._v("2")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Command & Control")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("cbm (m"), _c('sup', [_vm._v("3")]), _vm._v(")")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Cubic meter of fuel, equivalent to 1,000 litres or 744 kg")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Desantniki")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Russian term for troops who rode mounted on tanks or other AFVs into battle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("GABTU")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Glavnoe Avto-Brone-Tankovoe Upravlenie")]), _vm._v(" (Chief Department of Autos and Armoured Vehicles), 1940–45.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GAU KA")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Glavnye Artilleryiskye Upravlenue Krasnoy Armii")]), _vm._v(" (Main Artillery Directorate of Red Army)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Gefechtstroß")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Combat Trains, including ammunition trailers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Gepäcktroß")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Baggage Train, including field kitchens")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GCC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Guards Cavalry Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GKO")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Gosudarstvennij Komitet Oboroniy")]), _vm._v(" (State Defence Committee)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GMC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Guards Mechanized Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Großtransportraum")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Large Transport (GTR)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Guards Tank Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("HE-FRAG")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("High Explosive, Fragmentation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("HEAT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("High Explosive Anti-tank")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("HKL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Hauptkampflinie")]), _vm._v(" (main line of resistance)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("HVAP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("High Velocity Armour Piercing (Tungsten core)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Instandsetzungsgrupe")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Repair Group")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Kradschützen")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Motorcycle infantry")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("KwK")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Kampfwagenkanone")]), _vm._v(" (Fighting vehicle cannon)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("LSSAH")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Leibstandarte SS Adolf Hitler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("MC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Mechanized Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("MD")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Military District")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("NKO")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Narodnyi Kommisariat Oborony")]), _vm._v(" (the People’s Commissariat of Defence)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("NKTP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Narodnyi Komissariat Tankovoy Promyslennosti")]), _vm._v(" (the People’s Commissariat of the Tank Industry)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("NKVD")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Narodnyi Kommisariat Vneshnykh Del")]), _vm._v(" (People’s Commissariat of Internal Affairs)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("OKH")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Oberkommando des Heeres")]), _vm._v(" (German, Army High Command)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("OTB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Otdel’nyye tankovyye batal’ony")]), _vm._v(" (Separate Tank Battalion)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("OTTPP")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Otdel’nyye Tyazhelij Tankovij Polk Proriva")]), _vm._v(" (Independent Heavy Tank Breakthrough Regiment)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("PaK")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("PanzerAbwehrKanone")]), _vm._v(" (anti-tank gun)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("PP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("podderzhka pekhoty")]), _vm._v(" (infantry support tanks)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Pz.Rgt")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Panzer Regiment")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("PzAOK")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Panzerarmee")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("RKKA")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Raboche-Krest’yanskaya Krasnaya Armiya")]), _vm._v(" (the Army of Workers and Peasants/the Red Army)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("RVGK")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Rezerv Verkhovnogo Glavnokomandovaniya")]), _vm._v(" (Reserve of Supreme High Command)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("SAP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Samokhodno-Artillerijskij Polk")]), _vm._v(" (Self-Propelled Artillery Regiment)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("SPW")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Schützenpanzerwagen [Armoured Infantry Vehicle or APC]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("SR")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Schützen-Regiment [Motorized Infantry]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("TA")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Tank Army")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("TC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Tank Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("TSAP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Tyazhelij Samokhodno-Artillerijskij Polk")]), _vm._v(" (Heavy Self-Propelled Artillery Regiment)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("TTPP")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Tyazhelij Tankovij Polk Proriva")]), _vm._v(" (Heavy Tank Breakthrough Regiment)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("UABTTS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Uchebnyy Avtobronetankovyy Tsentr")]), _vm._v(" (Tank Automotive Training Centre)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("UMM")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Upravlenie Motorizatzii i Mekhanizatzii RKKA")]), _vm._v(" (Directorate of Mechanization and Motorization of the Red Army), 1929–1934. Re-named ABTU.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("VA")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("vozdushnaya armiya")]), _vm._v(" (Air Army)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("VAMM")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Voennaya Akademiya Mekhanizatzii i Motorizatzii RKKA")]), _vm._v(" (Military Academy of Mechanization and Motorization of the Red Army)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("V.S.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Verbrauchssatz")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("VVS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Voenno-Vozdushnye Sily")]), _vm._v(" (Military Air Forces) i.e. the "), _c('i', [_vm._v("Soviet Air Force")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Vorausabteilung")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Vanguard battalion (abbrev. V.A.)")])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172dfe08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Glossary.vue
// module id = 72
// module chunks = 0